import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import { data as categories } from '@lba-dev/package.local-globals/categories';
import company from '@lba-dev/package.local-globals/company';
import {
  checkIfMobileNumber
} from '@lba-dev/package.local-globals/verifyNumber';

import api from '../api';
import notifSystem from '../notifSystem';
import store from '../store';
import { setDialog, closeDialog } from './dialog';
import { openPDF } from '../utils/function';
import { openChatPanel } from './chatPanel';


export const count = (query, collection) =>
  api[collection]
    .getAll({
      call: 'count',
      query: JSON.stringify(query),
    })
    .then((res) => res.body().data())
    .catch(() => {
      notifSystem.error('Erreur', 'Impossible de récupérer le compteur');
      return 0;
    });

export function newVersionDialog() {
  return store.dispatch(
    setDialog({
      name: 'VerficationProp',
      open: true,
      hideClose: true,
      dialogProps: {
        title: '⚠️  Information  ⚠️',
        middle: true,
        fullScreenOn: false,
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
      },
      contentProps: {
        message:
          'Une nouvelle version est disponible\n' +
          'Redémarrage automatique, veuillez patienter',
      },
    })
  );
}

export function informNewVersion() {
  const { auth } = store.getState() || {};
  if (auth && auth.isRemotely) {
    newVersionDialog();
    return setTimeout(() => window.location.reload(true), 2000);
  }
  return setTimeout(() => {
    localStorage.setItem(
      'newVersion',
      JSON.stringify({
        status: true,
        forceUpdate: dayjs().add(1, 'h').toDate(),
      })
    );
    window.dispatchEvent(new Event('storage'));
  }, 1000 * 5);
}

export function checkMessagesToAnswer({ size }) {
  const state = store.getState();
  if (size > 0 && !state.dialog?.open) {
    store.dispatch(
      setDialog({
        name: 'VerficationProp',
        open: true,
        hideClose: true,
        dialogProps: {
          title: 'Messages à répondre',
          middle: true,
          fullScreenOn: false,
          disableEscapeKeyDown: true,
          disableBackdropClick: true,
        },
        contentProps: {
          message: 'Veuillez répondre aux messages reçus.',
        },
      })
    );
    return setTimeout(() => {
      store.dispatch(openChatPanel(null, 'artisan'));
      store.dispatch(setDialog({}));
    }, 1000);
  }
  return false;
}

export const openPreview = (obj, title, withLoading = true) => {
  if (withLoading) {
    store.dispatch(
      setDialog({
        name: 'LoadingDialog',
        open: true,
        dialogProps: { title: 'Prévisualisation en cours' },
      })
    );
  }
  return api
    .all('pdfhtmlform')
    .post(obj)
    .then((res) =>
      openPDF(`data:application/pdf;base64,${res.body().data()}`, title)
    )
    .catch(() => {
      if (!obj?.data?.devis?.id && obj?.data?.devis?.isCaldeo) {
        notifSystem.error(
          'Erreur caldeo',
          'Veuillez enregistrer le devis d\'abord'
        );
      } else {
        notifSystem.error(
          'Erreur system',
          'Le fichier n\'a pas pu être généré.'
        );
      }
    })
    .finally(() => withLoading && store.dispatch(closeDialog()));
};

export const openAssignDialog = ({
  data,
  collection,
  cb,
  field = 'ajout',
  filterUsers = false,
}) =>
  store.dispatch(
    setDialog({
      name: 'AssignDialog',
      open: true,
      contentProps: {
        field: (data.login || {})[field],
        filterUsers,
      },
      dialogProps: {
        title: 'Séléctionner un utilisateur',
        middle: true,
        middleAll: true,
      },
      actions: [
        {
          children: 'Assigner',
          onClick: (r, close) => {
            if (r.userSelected) {
              if (r.userSelected._id === (data.login || {})[field]) {
                close();
                return notifSystem.success(
                  'Opération réussie',
                  'Informations sauvegardées'
                );
              }
              return api[collection]
                .patch(data._id, { login: { [field]: r.userSelected._id } })
                .then(() => {
                  if (cb) {
                    cb(data, r.userSelected);
                  }
                  return notifSystem.success(
                    'Opération réussie',
                    'Informations sauvegardées'
                  );
                })
                .catch((e) =>
                  notifSystem.error(e.name, e.response ? e.response.data : e)
                )
                .finally(() => close());
            }
            return notifSystem.error(
              'Erreur',
              'Veuillez séléctionner un utilisateur valide'
            );
          },
        },
      ],
    })
  );

export function sendDemandePhotoAPI({
  userId, message, demandeId, tel, cb
}) {
  return api
    .one('sms', tel)
    .custom('send')
    .post({
      message,
      collection: 'sms',
      filters: JSON.stringify({
        to: { $in: [tel, `+33${+tel}`] },
        sender: true,
        $or: [
          { artisan: { $exists: true } },
          { intervention: { $exists: true } },
          { devis: { $exists: true } },
        ],
      }),
      newContact: true,
      isTemplate: true,
      hasWhatsapp: false,
    })
    .then(() => {
      notifSystem.success('Opération réussie', 'Le SMS a été envoyé');
      cb();
      if (demandeId) {
        api.history
          .post({
            date: new Date(),
            text: 'Une demande de photo a été envoyée',
            demandeId,
            userId,
          });
      }
    })
    .catch((e) =>
      notifSystem.error(
        e.name,
        e.response ? e.response.data : 'Le SMS n\'a pas pu être envoyé'
      )
    );
}

export const openCSVDialog = ({ uploadData, ...props }) =>
  store.dispatch(
    setDialog({
      name: 'DialogUploadCSV',
      open: true,
      contentProps: props,
      dialogProps: {
        title: 'Importation CSV',
        maxWidth: 'md',
      },
      actions: [
        {
          children: 'Importer',
          onClick: ({ data, month }, close) => {
            if (month && data && data.length) {
              uploadData(data, close);
            } else if (!month) {
              notifSystem.error(
                'Aucun mois sélectionné',
                'Veuillez sélectionner un mois'
              );
            } else {
              notifSystem.error(
                'Aucune donnée importer',
                'Veuillez ajouter un fichier CSV valid'
              );
            }
          },
        },
      ],
    })
  );

export function customConfirmDialog({
  title = 'Etes-vous sûr de faire cette action ?',
  dialogProps = {},
  contentProps = {},
  cb = (e) => e,
}) {
  return store.dispatch(
    setDialog({
      name: 'ConfirmDialog',
      open: true,
      hideClose: true,
      dialogProps: {
        title,
        ...dialogProps,
      },
      contentProps,
      actions: [
        {
          children: 'annuler',
          color: 'secondary',
          onClick: (data, close) => close(),
        },
        {
          children: 'Oui',
          color: 'primary',
          onClick: (data, close) => {
            cb();
            close();
          },
        },
      ],
    })
  );
}

export const searchElastic = ({ limit = 10, display = 0, collection, text }) =>
  api.elasticsearch.getAll({
    limit,
    collection,
    display,
    value: text,
  });

// Le lien de la page d'envoi de photos est ajouté par le back (raccourci via
// createUrl) une fois le SMS envoyé : ce message ne doit contenir que le
// texte, jamais le lien lui-même.
export const buildDemandePhotoMessage = (alias, categorieName, zipCode) => {
  let contexte = '';
  if (categorieName && zipCode) {
    contexte = ` pour votre demande de ${categorieName} (${zipCode})`;
  } else if (categorieName) {
    contexte = ` pour votre demande de ${categorieName}`;
  }
  return `Bonjour, ici ${company.name}. Pourriez-vous nous envoyer `
    + `quelques photos${contexte} ? Cela nous aidera à mieux vous conseiller. `
    + 'Merci d\'avance.';
};

export function demandePhoto(
  title,
  { tel = '', categorie = '', zipCode = '', demandeId, userId } = {},
  cb = f => f
) {
  const categorieName = categorie
    ? categories.find((e) => e._id === categorie).name
    : '';
  const { alias } = store.getState().connectedUser;
  const initialMessage = buildDemandePhotoMessage(
    alias, categorieName, zipCode
  );
  return store.dispatch(setDialog({
    name: 'DemandePhoto',
    open: true,
    hideClose: true,
    dialogProps: {
      title,
      middle: true,
      fullScreenOn: false,
      disableEscapeKeyDown: true,
    },
    contentProps: {
      tel: tel || '',
      categorie: categorieName,
      zipCode: zipCode || '',
      // `message` est ce que l'agent modifie ; `autoMessage` retient le
      // dernier texte auto-généré pour savoir, quand catégorie/code postal
      // changent, si le champ est encore intact ou déjà personnalisé (voir
      // DemandePhoto.js) -- sans ça, éditer le code postal après coup
      // écraserait un message que l'agent vient de réécrire à la main.
      message: initialMessage,
      autoMessage: initialMessage,
    },
    actions: [
      {
        children: 'Annuler',
        color: 'secondary',
        onClick: (r, close) => close(),
      },
      {
        children: 'Envoyer le SMS',
        onClick: (data, close) => {
          const {
            categorie, zipCode, tel, message
          } = data;
          const zipCodeRegex = /^[0-9]{5}$/;
          if (tel && categorie && zipCode) {
            if (!zipCodeRegex.test(zipCode) || !checkIfMobileNumber(tel)) {
              return notifSystem.error(
                'Erreur',
                'Le code postal ou le numéro de téléphone n\'est pas valide'
              );
            }
            close();
            return sendDemandePhotoAPI({
              message, demandeId, tel, userId, cb
            });
          }
          return notifSystem.error(
            'Erreur',
            'Veuillez remplir tous les champs'
          );
        },
      },
    ],
  }));
}

export const openValidateDevisSuppDialog = (onValidate) =>
  store.dispatch(
    setDialog({
      name: 'ValidateDevisSuppDialog',
      open: true,
      contentProps: { managing: 0 },
      dialogProps: {
        title: 'Attribution du devis',
        middle: true,
      },
      actions: [
        {
          children: 'Valider',
          onClick: (r, close) => {
            close();
            onValidate(r.managing);
          },
        },
      ],
    })
  );
